import React from 'react'

export default function TextValidation({ validate }) {
    return (
        <span style={{ color: 'red' }} hidden={!validate}>{validate}</span>
    )
}
